import React, { useEffect, useState } from "react";
// Assuming this is the component used in modal
import EmailPreview from "./EmailPreview";
import { Loading } from "../../Common";

const EmailPreviewPage = () => {
  const [emailPreviewProps, setEmailPreviewProps] = useState(null);

  useEffect(() => {
    const storedProps = localStorage.getItem("emailPreviewProps");
    if (storedProps) {
      setEmailPreviewProps(JSON.parse(storedProps));
    }
  }, []);

  if (!emailPreviewProps) {
    return <><Loading/></>;
  }

  return (
  
    <EmailPreview {...emailPreviewProps} />
  );
};

export default EmailPreviewPage;